import "./CTA.css";
import { FaArrowRight, FaPhoneAlt } from "react-icons/fa";

function CTA() {
  return (
    <section className="cta-section">

      <div className="cta-overlay"></div>

      <div className="container-custom">

        <div className="cta-content">

          <span className="cta-tag">
            READY TO WORK WITH US?
          </span>

          <h2>
            Innovative Packaging Solutions
            <br />
            Built For Modern Industries
          </h2>

          <p>
            Whether you need flexible packaging, industrial containers,
            films or customized bulk packaging solutions, our team is
            ready to help you choose the right solution for your business.
          </p>

          <div className="cta-buttons">

            <a
              href="#contact"
              className="btn-primary-custom"
            >
              Request A Quote

              <FaArrowRight />

            </a>

            <a
              href="tel:+919004290293"
              className="btn-outline-custom"
            >

              <FaPhoneAlt />

              +91 90042 90293

            </a>

          </div>

        </div>

      </div>

    </section>
  );
}

export default CTA;